import {
  API_TASK_COMPLETE_REQUEST,
  API_TASK_COMPLETE_FAILURE,
  API_TASK_COMPLETE_SUCCESS,
  CLEAR_COMPLETED_TASK,
} from 'common/types';

export const TASK_ACTION_HANDLERS = {
  [API_TASK_COMPLETE_REQUEST]: (state) => {
    return {
      ...state,
      context: {
        ...state.context,
        workflowTask: {...state.context.workflowTask, status: null},
      },
    };
  },
  [API_TASK_COMPLETE_FAILURE]: (state) => {
    return {
      ...state,
      context: {
        ...state.context,
        workflowTask: {
          ...state.context.workflowTask,
          status: null,
          error: 'Failed to complete task',
        },
      },
    };
  },
  [API_TASK_COMPLETE_SUCCESS]: (state, action) => {
    return {
      ...state,
      context: {
        ...state.context,
        workflowTask: {
          ...state.context.workflowTask,
          status: action.payload,
        },
      },
    };
  },
  [CLEAR_COMPLETED_TASK]: (state) => {
    return {...state, context: {...state.context, workflowTask: null}};
  },
};
